/**
 * SYNCED FROM SERVER — do not edit by hand.
 *
 * Source: `server/src/api/<domain>/<domain>.contract.ts` (or the
 * shared bases under `server/src/api/common/contracts/`).
 *
 * Regenerate: `cd api-client && bun run sync:contracts`.
 *
 * The server is the source of truth for contract definitions. This
 * file exists so the web SPA can import zod schemas + oRPC contract
 * types from `@event-manager/api-client/contracts/<domain>.contract`
 * without reaching into the server workspace.
 */

/**
 * Standard Error Data Envelope
 *
 * Every ORPCError.data should conform to this shape.
 * This provides a consistent error format for all API errors.
 */
import * as z from "zod";

/**
 * Standard error data envelope for all oRPC errors.
 */
export const ErrorDataSchema = z.object({
	/** Machine-readable error code (e.g., 'NOT_FOUND', 'DATABASE_ERROR') */
	code: z.string(),
	/** Human-readable error message */
	message: z.string().optional(),
	/** Affected resource type (e.g., 'User', 'Event') */
	resource: z.string().optional(),
	/** Affected field name (for conflict errors) */
	field: z.string().optional(),
	/** Validation errors array (for BAD_REQUEST) */
	errors: z
		.array(
			z.object({
				path: z.string(),
				message: z.string(),
				code: z.string().optional(),
			})
		)
		.optional(),
	/** Additional details (only in non-production) */
	details: z.unknown().optional(),
});

export type ErrorData = z.infer<typeof ErrorDataSchema>;
